import type { ReactNode } from "react";
import { useAuthSession } from "../api/auth";
import { useDocumentTitle } from "../hooks/useDocumentTitle";

export function AuthGate({ children }: { children: ReactNode }) {
  const { data, isPending, isError } = useAuthSession();
  const gated = Boolean(
    isPending || isError || !data || (data.status !== "disabled" && data.status !== "ok")
  );
  const authTitle = isPending
    ? undefined
    : data?.status === "unprovisioned"
      ? "Access needed"
      : data?.status === "anon"
        ? "Sign in"
        : isError || !data
          ? "Unavailable"
          : undefined;
  useDocumentTitle(authTitle, gated);

  if (isPending) {
    return (
      <div className="auth-gate">
        <p>Loading…</p>
      </div>
    );
  }

  if (isError || !data) {
    return (
      <div className="auth-gate">
        <h1>Silph Scope</h1>
        <p>Could not reach the API. Is it running?</p>
      </div>
    );
  }

  if (data.status === "disabled" || data.status === "ok") return <>{children}</>;

  if (data.status === "unprovisioned") {
    return (
      <div className="auth-gate">
        <img src="/assets/silph-scope-mark.png" alt="" width={48} height={48} />
        <h1>Access needed</h1>
        <p>
          Signed in{data.email ? ` as ${data.email}` : ""}, but you have no Silph Scope role yet. Ask
          for the JumpCloud group <code>app-silph-scope-guest</code> (Calendar only),{" "}
          <code>app-silph-scope-member</code>, or <code>app-silph-scope-admin</code>.
        </p>
        <a className="btn-primary" href={data.cfg.logoutUrl}>
          Sign out
        </a>
      </div>
    );
  }

  return (
    <div className="auth-gate">
      <img src="/assets/silph-scope-mark.png" alt="" width={48} height={48} />
      <h1>Silph Scope</h1>
      <p>Internal analytics. Sign in with your Parsec account (JumpCloud via parsec-id).</p>
      <a className="btn-primary" href={data.cfg.loginUrl}>
        Sign in
      </a>
    </div>
  );
}
